import PropTypes from 'prop-types';
import { Box } from '@mui/material';

import classes from './TabPanel.module.css';


const CustomTabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
            className={classes.TabPanel}
        >
            {
                value === index &&
                <Box sx={{ p: 3 }}>
                    {props.children}
                </Box>
            }
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};
export default CustomTabPanel;